import React, { useState, useEffect } from 'react';
import { Table, Input, Select, Space, Tag } from 'antd';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

const { Option } = Select;

const PaymentHistory = () => {
  const [paymentData, setPaymentData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    // Fetch payment history data from API
    fetch('https://api.raoosastro.com/paymenthistory')
      .then((response) => response.json())
      .then((data) => {
        setPaymentData(data);
        setFilteredData(data); // Initialize filtered data with the full payment data
      })
      .catch((error) => {
        console.error('Error fetching payment data:', error);
      });
  }, []);

  // Function to handle the search functionality
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);

    const filtered = paymentData.filter((payment) => {
      return (
        (payment.transactionId.toLowerCase().includes(value.toLowerCase()) ||
          payment.phoneNumber.includes(value) ||
          payment.email.toLowerCase().includes(value.toLowerCase())) &&
        (statusFilter ? payment.status === statusFilter : true)
      );
    });
    setFilteredData(filtered);
  };

  // Function to handle status filter
  const handleStatusFilter = (value) => {
    setStatusFilter(value);

    const filtered = paymentData.filter((payment) => {
      return (
        (value ? payment.status === value : true) && 
        (payment.transactionId.toLowerCase().includes(searchText.toLowerCase()) ||
         payment.phoneNumber.includes(searchText) ||
         payment.email.toLowerCase().includes(searchText.toLowerCase()))
      );
    });
    setFilteredData(filtered);
  };

  // Define the columns for the Ant Design table
  const columns = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = '';
        if (status === 'PAID') color = 'green';
        if (status === 'NOT PAID') color = 'volcano';
        if (status === 'PENDING') color = 'orange';

        return <Tag color={color}>{status}</Tag>;
      },
      filters: [
        { text: 'Paid', value: 'PAID' },
        { text: 'Not Paid', value: 'NOT PAID' },
        { text: 'Pending', value: 'PENDING' },
      ],
      onFilter: (value, record) => record.status.toLowerCase() === value.toLowerCase(),
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (text) => new Date(text).toLocaleString(),
      sorter: (a, b) => new Date(b.date) - new Date(a.date),
    },
    {
      title: 'Transaction ID',
      dataIndex: 'transactionId',
      key: 'transactionId',
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ margin: '20px' }}>
        <Space style={{ marginBottom: 16 }}>
          <Input
            placeholder="Search by Transaction ID, Phone Number, or Email"
            value={searchText}
            onChange={handleSearch} // Automatically search as the user types
            style={{ width: 300 }}
          />
          <Select
            style={{ width: 150 }}
            placeholder="Filter by Status"
            value={statusFilter}
            onChange={handleStatusFilter}
            allowClear
          >
            <Option value="PAID">Paid</Option>
            <Option value="NOT PAID">Not Paid</Option>
            <Option value="PENDING">Pending</Option>
          </Select>
        </Space>
        <Table
          dataSource={filteredData}
          columns={columns}
          rowKey="_id"
          pagination={false}
          bordered
        />
      </div>
    </DashboardLayout>
  );
};

export default PaymentHistory;
